export const FEEDBACK_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSdjw5_Q-QmCChechdq3bjsxoSzQ5kYgnyCZ7tpIMSND6CbniA/viewform?usp=header'
